module.exports = __webpack_public_path__ + "static/media/wmTrial-numbers-2.90ef26ad.mp3";